/**
 * Auth0 tenant configuration per region.
 *
 * Each customer's vanity URL is mapped to an Auth0 tenant region via the
 * home-realm-discovery CloudFront function (KVS value format: "ConnectionName,Region").
 * This module maps that region code to the Auth0 SPA config needed by Auth0Provider.
 *
 * Note: Auth0 tenant region is independent of API region. A customer may
 * authenticate via the AU Auth0 tenant but have their API hosted in US.
 */

const AUTH0_TENANTS = {
  AU: {
    domain: "id.orchestrated.io",
    clientId: "suYwzcyl0pErk3cYZGQ9SjSevqGeAouz",
    audience: "https://orchestrated-integration.au.auth0.com/api/v2/",
  },
  US: {
    domain: "id.us.teamform.co",
    clientId: "A3xeBBHrbgexDrPvG1n8YudqeUrkTgmX",
    audience: "https://teamform-us.us.auth0.com/api/v2/",
  },
  EU: {
    domain: "id.eu.teamform.co",
    clientId: null, // TODO: Register TeamForm App UI SPA in teamform-eu Auth0 tenant
    audience: null, // TODO: Set once SPA is registered
  },
};

const DEFAULT_REGION = "AU";

export const PROD_AUTH0_DOMAINS = Object.values(AUTH0_TENANTS)
  .map((t) => t.domain)
  .filter(Boolean);

/**
 * Returns Auth0 config for the given region, falling back to AU.
 * @param {string | null | undefined} region - "AU", "US", or "EU"
 * @returns {{ domain: string, clientId: string, audience: string }}
 */
export const getAuth0ConfigForRegion = (region) => {
  const tenant = AUTH0_TENANTS[region];
  if (tenant && tenant.domain && tenant.clientId && tenant.audience) {
    return tenant;
  }
  return AUTH0_TENANTS[DEFAULT_REGION];
};

export default AUTH0_TENANTS;
